import React, { useState } from "react";
import { LARIS_SEGMENTS } from "./IntegratedSegmentsData";
import "./IntegratedSegmentsLayouts.css";

/** Expandable card grid - click to expand, content inside card, single expand */
export function SegmentsLayoutExpandableGrid({
  segments = LARIS_SEGMENTS,
  animationMode = "none",
  hoverMode = "default",
  inView = false,
  initialExpandedId,
}) {
  const [expandedId, setExpandedId] = useState(initialExpandedId ?? segments[0]?.id ?? "receptionist");

  const handleClick = (seg) => {
    setExpandedId((prev) => (prev === seg.id ? null : seg.id));
  };

  const handleKeyDown = (e, seg) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick(seg);
    }
  };

  const gridClasses = [
    "laris-segments-expandable-grid",
    `laris-segments-anim-${animationMode}`,
    `laris-segments-hover-${hoverMode}`,
    inView ? "laris-segments-in-view" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className={gridClasses}>
      {segments.map((seg, idx) => {
        const isExpanded = expandedId === seg.id;
        return (
          <div
            key={seg.id}
            className={`laris-expandable-card-wrapper ${isExpanded ? "expanded" : ""}`}
            style={
              isExpanded
                ? { gridRow: "span 2", gridColumn: "span 2" }
                : undefined
            }
            data-segment-index={idx}
          >
            <button
              type="button"
              role="button"
              className="laris-expandable-card"
              onClick={() => handleClick(seg)}
              onKeyDown={(e) => handleKeyDown(e, seg)}
              aria-expanded={isExpanded}
              aria-controls={`expandable-content-${seg.id}`}
              id={`expandable-trigger-${seg.id}`}
            >
              <div className="laris-expandable-card-header">
                <img src={seg.icon} alt="" width="40" aria-hidden="true" />
                <h5 className="laris-expandable-card-title">{seg.title}</h5>
              </div>
              <div
                id={`expandable-content-${seg.id}`}
                className="laris-expandable-card-content"
                aria-hidden={!isExpanded}
              >
                <p>{seg.description}</p>
              </div>
            </button>
          </div>
        );
      })}
    </div>
  );
}
